import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const RestoredRowContainer = styled.div`
  width: 100%;
  padding: ${pxToRem(12)} ${pxToRem(20)};
  background: ${({ theme }) => theme.colors.success};

  display: flex;
  justify-content: left;
  align-items: center;
  padding: ${pxToRem(8)} ${pxToRem(24)};
`;

export const RestoredRowMessage = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${pxToRem(18)};
  font-weight: 400;
  padding-left: ${pxToRem(32)};
`;
